import { CastMediaSession, CastSession } from '../interfaces';

type CastMessageType = 'SEEK' | 'GET_STATUS';

interface BaseCastMessage {
  type: CastMessageType;
}

interface SeekMessage extends BaseCastMessage {
  type: 'SEEK';
  currentTime: number;
}

interface GetStatusMessage extends BaseCastMessage {
  type: 'GET_STATUS';
}

type CastMessage = SeekMessage | GetStatusMessage;

export class CastMessageManager {
  private requestId = Math.floor(Math.random() * Math.floor(2222222));

  constructor(private readonly session: CastSession, private readonly media: CastMediaSession) {}

  public send(message: CastMessage) {
    switch (message.type) {
      case 'SEEK':
        return this.sendSeek(message);
      case 'GET_STATUS':
        return this.sendGetStatus(message);
    }
  }

  private options() {
    return {
      requestId: ++this.requestId,
      mediaSessionId: this.media.mediaSessionId,
    } as const;
  }

  private sendSeek(message: SeekMessage) {
    this.session.sendMessage('urn:x-cast:com.google.cast.media', {
      type: message.type,
      currentTime: message.currentTime,
      ...this.options(),
    });
  }

  private sendGetStatus(message: GetStatusMessage) {
    this.session.sendMessage('urn:x-cast:com.google.cast.media', {
      type: message.type,
      ...this.options(),
    });
  }
}
